'use client';

import PropTypes from 'prop-types';

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import Markdown from "src/components/markdown";

import RecipeStepsGallery from "./recipe-steps-gallery";

const splitStepsIntoGroups = (steps) => {
  const stepsInGroups = {};

  steps.forEach(step => {
    const stepGroupId = step.groupId;
    if (stepGroupId in stepsInGroups) {
      stepsInGroups[stepGroupId].list.push(step);
    } else {
      stepsInGroups[stepGroupId] = {
        label: step.groupName,
        list: [step]
      };
    }
  });

  return stepsInGroups;
}

function RecipeSteps({recipeData}) {
  if (!recipeData.steps || recipeData.steps.length < 1) {
    return '';
  }

  const stepsInGroups = splitStepsIntoGroups(recipeData.steps);

  return (
    <Stack spacing={2}>
        <Typography variant="h6">Wykonanie</Typography>

        <Box
          rowGap={2}
          display="grid"
          gridTemplateColumns={{
            xs: 'repeat(1, 1fr)'
          }}
        >
          {Object.keys(stepsInGroups).map((stepGroupKey, idx) => (
              <Stack key={`${idx}-${stepGroupKey}`} spacing={1} direction="column">
                <Typography variant="subtitle1">
                  {`Etap ${idx + 1}. `}
                  {stepsInGroups[stepGroupKey].label}
                </Typography>
                {
                  stepsInGroups[stepGroupKey].list.map((step, stepIdx) => (
                    <Box key={`${stepIdx}-${step.id}-box`}>
                      <Markdown children={step.stepDescription} sx={{display: 'inline'}}/>
                      <Stack key={`${stepIdx}-${step.id}-photo-stack`}>
                        <RecipeStepsGallery stepPhotos={step.images} sx={{
                          mt: 1
                        }}/>
                      </Stack>
                    </Box>
                  ))
                }
              </Stack>
            )
          )}
        </Box>
      </Stack>
  );
}

RecipeSteps.propTypes = {
  recipeData: PropTypes.object
}

export default RecipeSteps;
